import { FC } from 'react'
import Link from 'next/link'

type Props = {}

const Component: FC<Props> = ({ }) => {
  const webp = "/iot_banner.webp"
  const avif = "/iot_banner.avif"
  const url = "/iot_banner.png"
  return (
    <>
      <div className="flex flex-col-reverse md:flex-row w-full rounded-[4px]">
        <div className="flex flex-col justify-center items-center md:w-1/2 bg-primary-900 text-white">
          <p className="font-semibold w-2/3 text-center">IoT/M2M向けSIMについて<br />お問い合わせ</p>
          <p className="w-4/5 text-center my-4">
            IoT/M2M向けSIMについてご興味が
            <br />
            ある方はお問い合わせください。
          </p>

          <Link href="/lp" prefetch={false}>
            <a className="bg-accent-500 my-4 text-primary-900 py-2 px-5 rounded-[4px] font-semibold shadow hover:shadow-md">
              問い合わせする
            </a>
          </Link>
        </div>

        <Link href="/lp" prefetch={false}>
          <a className="flex flex-col justify-center items-center md:w-1/2 bg-white  min-h-min aspect-auto">
            <picture className="h-full">
              <source srcSet={avif} type="image/avif" />
              <source srcSet={webp} type="image/webp" />
              <img src={url} width="100%" height="100%" alt="iot_banner" loading="lazy" className="h-full" />
            </picture>
          </a>
        </Link>
      </div>
    </>
  )
}

export default Component
